module.exports = __webpack_public_path__ + "static/wpack/extracted/mail-20d8239d48857f698579c1a8d9b6c6f89.svg";